var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4294 1H1.71512C1.41202 1 1.12133 1.12041 0.907001 1.33474C0.692673 1.54906 0.572266 1.83975 0.572266 2.14286V9C0.572266 9.3031 0.692673 9.59379 0.907001 9.80812C1.12133 10.0224 1.41202 10.1429 1.71512 10.1429H11.4294C11.7325 10.1429 12.0232 10.0224 12.2375 9.80812C12.4519 9.59379 12.5723 9.3031 12.5723 9V2.14286C12.5723 1.83975 12.4519 1.54906 12.2375 1.33474C12.0232 1.12041 11.7325 1 11.4294 1Z",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.9997H14.2857C14.5888 12.9997 14.8795 12.8793 15.0938 12.665C15.3082 12.4507 15.4286 12.16 15.4286 11.8569V6.14258",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88728 5.6935C2.8115 5.6935 2.73883 5.6634 2.68525 5.60982C2.63166 5.55623 2.60156 5.48356 2.60156 5.40778C2.60156 5.33201 2.63166 5.25934 2.68525 5.20575C2.73883 5.15217 2.8115 5.12207 2.88728 5.12207",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88672 5.6935C2.96249 5.6935 3.03517 5.6634 3.08875 5.60982C3.14233 5.55623 3.17243 5.48356 3.17243 5.40778C3.17243 5.33201 3.14233 5.25934 3.08875 5.20575C3.03517 5.15217 2.96249 5.12207 2.88672 5.12207",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2584 5.6935C10.1826 5.6935 10.1099 5.6634 10.0563 5.60982C10.0028 5.55623 9.97266 5.48356 9.97266 5.40778C9.97266 5.33201 10.0028 5.25934 10.0563 5.20575C10.1099 5.15217 10.1826 5.12207 10.2584 5.12207",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2578 5.6935C10.3336 5.6935 10.4063 5.6634 10.4598 5.60982C10.5134 5.55623 10.5435 5.48356 10.5435 5.40778C10.5435 5.33201 10.5134 5.25934 10.4598 5.20575C10.4063 5.15217 10.3336 5.12207 10.2578 5.12207",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5731 6.99972C6.95198 6.99972 7.31535 6.84921 7.58326 6.5813C7.85116 6.31339 8.00167 5.95003 8.00167 5.57115C8.00167 5.19227 7.85116 4.82891 7.58326 4.561C7.31535 4.29309 6.95198 4.14258 6.5731 4.14258C6.19422 4.14258 5.83086 4.29309 5.56295 4.561C5.29504 4.82891 5.14453 5.19227 5.14453 5.57115C5.14453 5.95003 5.29504 6.31339 5.56295 6.5813C5.83086 6.84921 6.19422 6.99972 6.5731 6.99972Z",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingHistoryIcon);
export default __webpack_public_path__ + "static/media/billing-history-icon.8afc82fa919e3cd3ce8d26dbe72843eb.svg";
export { ForwardRef as ReactComponent };